import axios from 'axios'
import { API_URL } from '../../../../modules/auth/core/_requests'

export interface OrderImageRecord {
  id: number;
  workflow_id: number;
  image_url: string;
  filename: string;
  created_at: Date;
}

export async function getOrderImages(workflowId: number): Promise<OrderImageRecord[]> {
  try {
    const response = await axios.get(`${API_URL}/api/shopify-shipping/shared/order-images/${workflowId}`)
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        throw new Error(`API error: ${error.response.status} ${error.response.statusText}`)
      } else {
        throw new Error('Network error when fetching order images')
      }
    }
    throw new Error(`Failed to retrieve order images: ${error instanceof Error ? error.message : 'Unknown error'}`)
  }
}